import { InvoiceTaxModel } from './invoicetax.model';

export class ExpenseModel {
  id?: number;
  unityAmount: number;
  taxes: Array<InvoiceTaxModel>;
  quantity: number;
  expenseAccount: string;
  customsValue: number;
  contactPropertyUid: number;
  projectUid?: string;
  expenseProjectTypeUid?: string;

  // Clasificador de gastos (partida/subpartida/familia) por concepto - transitorio
  clasificadorPartida?: string;
  clasificadorSubpartida?: string;
  clasificadorFamilia?: string;

  constructor() {
    this.taxes = new Array<InvoiceTaxModel>();
    this.unityAmount = 0;
    this.quantity = 1;
    this.expenseAccount = null;
    this.customsValue = null;
  }
}
